import classNames from 'classnames';
import React from 'react';
import styled from "styled-components";
import { isURL } from 'validator';
import { AutomationTestIdElementType, AutomationTestIdFeature, createDataTestId } from '../../utilities/automation';
import Picture from '../Picture';
import { useIsMobile } from "../../context/MobileContext";
import ArrowRight from "../../images/arrow-right.svg";


const EmployeeContainer = styled.div`
    .card-body {
        padding-top: 2.222rem;
    }

    .card-body h3 a {
        text-decoration: none;
        color:#000;
    }

    .card-body h3 a:hover {
        text-decoration: underline;
    }

    .card-body p a {
        text-decoration: none;
        color:#000;
    }

    .card-body p a:hover {
        text-decoration: underline;
    }

    .card a picture, .card a picture img {
        aspect-ratio: 4/3;
        object-fit: cover;
    }

    .card-footer {
        padding-bottom: 2.222rem !important;
    }

    .contact-info {
        font-weight: 500;
        margin-bottom: 0;
        line-height: 150%
    }

    @media (max-width: 991px) {
        .card {
            flex-shrink: 0;
            flex-direction: row;

            a picture {
                display: flex;
                width: 80px;
                height: 100%;
                flex-shrink: 0;
            }

            .mobile-arrow {
                width: 30px;
                margin-right: 20px;
                filter: brightness(100);
            }
        }

        .card-body {
            padding: 20px !important;

            h3 {
                font-size: 24px;
                font-weight: 500;
                line-height: 110%;
            }

            h5 {
                font-size: 16px;
                font-weight: 400;
                line-height: 150%;
            }

            p {
                margin-bottom: 0px !important;
            }
        }
    }
`;

export default function Employee(props) {
    const { name, title, number, email, nmls, picture, bio, widget_body_text, widget_cta_text, widget_cta_link, cardClass, cardButtonClass } = props;
    const pictureUrl = picture.match(/^https/) ? picture : `${process.env.GATSBY_MEDIA_URL}${picture.replace(/^\/?media/, '')}`;
    const { isMobileWidth } = useIsMobile();

    function showButton() {
        if (!widget_cta_link) return;

        return (
            <div className="card-footer border-0 pb-4 pt-0">
                {isURL(widget_cta_link) ?
                <a className={classNames("btn w-100", cardButtonClass)} target="_blank" href={widget_cta_link.match(/^https|^http/) ? widget_cta_link : `//${widget_cta_link}`}>
                    {widget_cta_text || "Schedule an appointment"}
                </a>
                :
                <button
                    data-delay="1" data-height="640" data-psz="00" data-so-page={widget_cta_link} id={`SOIBTN_${widget_cta_link}`}
                    className={classNames("btn w-100", cardButtonClass)}>{widget_cta_text || "Schedule an appointment"}
                </button>
                }
            </div>
        );
    }

    return (
        <EmployeeContainer className="col-sm-12 col-md-6 col-lg-3 py-2" data-test-id={createDataTestId({feature: AutomationTestIdFeature.EMPLOYEE_LOOKUP, element: AutomationTestIdElementType.COLLECTION_ITEM})}>
            <div className={classNames("card border-0 rounded-0 h-100", cardClass)}>
                <a href={bio} data-test-id={createDataTestId({feature: AutomationTestIdFeature.EMPLOYEE_LOOKUP, element: AutomationTestIdElementType.LINK, specifier: 'image'})}>
                    <Picture data-test-id={createDataTestId({feature: AutomationTestIdFeature.EMPLOYEE_LOOKUP, element: AutomationTestIdElementType.IMAGE})} alt={name} src={pictureUrl} style={{maxHeight: "100%", height: "100%", maxWidth: "100%", width: "100%", objectFit: 'cover', objectPosition: 'center'}} className="ae-img" />
                </a>
                <div className={classNames("card-body px-4", cardClass)}>
                    <h3><a className={classNames(cardClass, isMobileWidth && 'stretched-link')} href={bio} data-test-id={createDataTestId({feature: AutomationTestIdFeature.EMPLOYEE_LOOKUP, element: AutomationTestIdElementType.LINK, specifier: 'name'})}>{name}</a></h3>
                    <p className={cardClass}>{title}</p>
                    {!isMobileWidth && widget_body_text && <p>{widget_body_text}</p>}
                    {!isMobileWidth && number && <p className='contact-info'><a className={cardClass} href={`tel:${number}`}>{number}</a></p>}
                    {!isMobileWidth && email && <p className='contact-info'><a className={cardClass} href={`mailto:${email}`}>{email}</a></p>}
                    {!isMobileWidth && nmls && <p className='contact-info'>NMLS ID: {nmls}</p>}
                </div>
                {!isMobileWidth && showButton()}
                {isMobileWidth && <img src={ArrowRight} className='mobile-arrow'></img>}
            </div>
        </EmployeeContainer>
    );
};
